/* eslint-disable */
import React, { useMemo } from 'react';
import _ from 'lodash';
import { Grid } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Store } from 'react-notifications-component';
import PropTypes from 'prop-types';

import TableHeader from './Table/Header';
import TableLoader from './Table/Loader';
import TableEmptySearch from './Table/EmptySearch';
import TableEmptyServices from './Table/EmptyServices';
import TableBody from './Table/Body/SortableContainer';

import { getErrorMessage, getSortedCategory, getSortedServices, getMassActionList } from '../../helpers/getters';
import { changePositionService, changePositionCategory, serviceTableLoading, changePositionError, changePositionCategoryError } from '../../reducer';
import { servicesChangePositionCategory, servicesChangePositionServices } from '../../../../../redux/actions/services';
import { CHANGE_START } from '../../reducer/constants';

const ServicesListing = ({ serviceTable, servicesChecked, config, serviceDispatch }) => {
  const dispatch = useDispatch();

  const massActions = useMemo(() => getMassActionList(config), [config]);

  const { isLoadingTable, search, searchOption, list, startList, scrollToCategoryId, scrollToServiceId, sortCategoryStart } = serviceTable;

  const isEmptySearch = search && !list.length;
  const isEmptyServices = !search && !startList.length;

  const onSortStart = ({ index }, event) => {
    event.preventDefault();
    if (list[index].collection === 'category') {
      serviceDispatch({
        type: CHANGE_START,
        payload: {
          index,
          category_id: list[index].id,
        },
      });
    }
  };

  const onSortEnd = async ({ oldIndex, newIndex, collection }) => {
    if (oldIndex !== newIndex) {
      try {
        // Sort Category
        if (_.isNull(collection)) {
          const sortList = sortCategoryStart?.list || list;
          const sortStartList = sortCategoryStart?.startList || startList;
          if (sortList.length !== newIndex + 1) {
            const positions = await getSortedCategory(list, sortStartList, sortList[oldIndex].categoryIndex, newIndex);
            await serviceDispatch(serviceTableLoading());
            await dispatch(servicesChangePositionCategory(positions));
            const categoryIdSorted = sortList[oldIndex].id;
            return await serviceDispatch(changePositionCategory(categoryIdSorted));
          } else {
            await serviceDispatch(changePositionCategoryError());
            return Store.addNotification({
              title: 'Warning',
              message: 'Last position can not be applied',
              type: 'warning',
              insert: 'top',
              container: 'bottom-right',
              animationIn: ['animate__animated', 'animate__fadeIn'],
              animationOut: ['animate__animated', 'animate__fadeOut'],
              dismiss: {
                duration: 3000,
              },
            });
          }
        }
        // Sort services
        if (_.isNumber(collection)) {
          const categoryId = collection;
          const positions = await getSortedServices(list, startList, oldIndex, newIndex);
          await serviceDispatch(serviceTableLoading());
          await dispatch(servicesChangePositionServices(categoryId, positions));
          const serviceIdSorted = list[oldIndex].id;
          await serviceDispatch(changePositionService(serviceIdSorted));
          return true;
        }
      } catch (error) {
        await serviceDispatch(changePositionCategoryError());
        const errorMessage = getErrorMessage(error);
        await Store.addNotification({
          title: 'Error',
          message: errorMessage,
          type: 'danger',
          insert: 'top',
          container: 'bottom-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
          },
        });
        await serviceDispatch(changePositionError());
        return false;
      }
      return new Error('Undefined collection');
    } else {
      if (_.isNull(collection)) {
        await serviceDispatch(changePositionCategoryError());
      }
    }
  };

  return (
    <Grid fluid>
      <TableHeader
        config={config}
        serviceTable={serviceTable}
        serviceDispatch={serviceDispatch}
        servicesChecked={servicesChecked}
        massActions={massActions}
        list={list}
      />
      <div className="service-table__relative">
        {isEmptySearch ? <TableEmptySearch search={search} searchOption={searchOption} /> : null}
        {isEmptyServices ? <TableEmptyServices search={search} serviceDispatch={serviceDispatch} /> : null}
        {isLoadingTable ? <TableLoader /> : null}
        <TableBody
          helperClass="service-table__drag-helper"
          useDragHandle
          onSortStart={onSortStart}
          onSortEnd={onSortEnd}
          config={config}
          isLoadingTable={isLoadingTable}
          serviceDispatch={serviceDispatch}
          massActions={massActions}
          search={search}
          searchOption={searchOption}
          scrollToCategoryId={scrollToCategoryId}
          scrollToServiceId={scrollToServiceId}
          servicesChecked={servicesChecked}
          list={list}
        />
      </div>
    </Grid>
  );
};

ServicesListing.propTypes = {
  serviceTable: PropTypes.object,
  servicesChecked: PropTypes.array,
  config: PropTypes.object,
  serviceDispatch: PropTypes.func,
};

export default ServicesListing;
